var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription cancel"},[_vm._v("CANCEL!!!")])
}
var staticRenderFns = []

export { render, staticRenderFns }